module.exports = __webpack_public_path__ + "static/media/cardFour.d19ab697.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowTwo/cardFour.jpg
// module id = 17
// module chunks = 0